import { useNavigate, useLocation } from 'react-router-dom'
import { skipToken } from '@reduxjs/toolkit/query'
import Button from '@mui/material/Button'
import PolicyIcon from '@mui/icons-material/Policy'

import { SnackbarType } from '$/types'
import { useAppSelector } from 'app/hooks'
import { useGetQRAAssessmentQuery } from 'app/services/api/qra/assessments'
import useClickOutside from './useClickOutside'
import { selectSavedStateViewInfo } from 'features/RiskManagement/Assessments/States/qraSavedStateSelectors'

const NewAssessmentCompleted = ({ onClose }: SnackbarType) => {
  const location = useLocation()
  const navigate = useNavigate()

  const snackbarRef = useClickOutside(onClose)

  const savedStateInfo = useAppSelector(selectSavedStateViewInfo)

  const { currentData: completedAssessment } = useGetQRAAssessmentQuery(
    savedStateInfo?.lastInProcessAssessmentId?.toString() ?? skipToken
  )

  const savedStateParentPath = location.pathname.slice(
    0,
    location.pathname.toLowerCase().lastIndexOf('/states')
  )

  const browseAssessment = (): void => {
    navigate({
      pathname: [
        savedStateParentPath,
        '/states/',
        savedStateInfo?.stateId,
        '/assessments/',
        completedAssessment?.id
      ].join(''),
      search: location.search
    })

    onClose()
  }

  const buttonsPanel = [
    {
      text: 'DISMISS',
      action: onClose,
      containerClasses: '',
      buttonClasses: {}
    },
    {
      text: 'VIEW',
      action: browseAssessment,
      containerClasses: 'bg-lighthouseBlue',
      buttonClasses: { color: 'white' }
    }
  ]

  return (
    <div className='flex items-center rounded bg-black p-2' ref={snackbarRef}>
      <PolicyIcon className='text-white ml-2' />
      <div className='ml-2 font-light text-white'>
        <span>What-If Scenario</span>
        <span className='mx-1 font-medium'>{completedAssessment?.name}</span>
        <span>has finished processing.</span>
      </div>
      <div className='flex ml-20'>
        {buttonsPanel.map((button) => (
          <div
            key={button.text}
            className={`mr-2 rounded ${button.containerClasses}`}
          >
            <Button
              key={button.text}
              onClick={button.action}
              sx={button.buttonClasses}
            >
              {button.text}
            </Button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default NewAssessmentCompleted
